import { GetterTree } from 'vuex'
import RootState from '@vue-storefront/core/types/RootState'
import UserState from '../types/UserState'
import rootStore from '@vue-storefront/core/store'

const getters: GetterTree<UserState, RootState> = {
  isLoggedIn (state) {
    return state.current !== null
  },
  isLocalDataLoaded: state => state.local_data_loaded,
  getUserToken (state) {
    return state.token
  },
  getOrdersHistory (state) {
    return state.orders_history
  },
  getLastOrderHistoryPage (state) {
    return state.last_page
  },
  getOrder (state) {
    return state.order
  },
  getOrderedLocations (state) {
    return state.ordered_locations
  },
  getOrderAgeConfirmation (state) {
    return state.orderAgeConfirmation
  },
  getRefreshToken (state) {
    return state.refreshToken
  },
  currentAddresses (state) {
    let addresses = rootStore.getters['user/address/getAddressList']
    return state.current && addresses && addresses.length ? addresses : []
  },
  getPhoneNumber: state => (isCheckout = false) => {
    let addresses = rootStore.getters['user/address/getAddressList']
    let phoneNumber = state.current ? state.current.telephone : false,
        address = state.current && addresses && addresses.length ? addresses.find(addr => addr.id > 0) : false

    if (!phoneNumber && address) {
      phoneNumber = address.telephone
    }

    if (!phoneNumber && isCheckout) {
      let personalDetails = rootStore.getters['checkout/getPersonalDetails']
      if (personalDetails && personalDetails.phoneNumber) {
        phoneNumber = personalDetails.phoneNumber
      }
    }

    if (phoneNumber && String(phoneNumber).startsWith('0')) {
      phoneNumber = `38${phoneNumber}`
    }

    return phoneNumber ? phoneNumber : false
  },
  getCustomerIp: state => state.headers['ip_address'],
  getCustomerUA: state => state.headers['user-agent'] ? state.headers['user-agent'] : '',
  getCustomerAccept: state => state.headers['accept'],
  getCurrentUser: state => state.current,
  getDevice: (state, getters) => {
    if (/iphone/i.test(getters.getCustomerUA.toLowerCase()) && /safari/i.test(getters.getCustomerUA.toLowerCase())) {
      return 'iphone'
    } else if (/android/i.test(getters.getCustomerUA.toLowerCase()) || /chrome/i.test(getters.getCustomerUA.toLowerCase())) {
      return 'android'
    } else {
      return ''
    }
  }
}

export default getters
